<ng-container>
    <h2 mat-dialog-title>Migrate Simulation Model</h2>
    <mat-spinner mode="indeterminate" *ngIf="inProgress" diameter="20"></mat-spinner>
    <mat-dialog-content class="mat-typography">
        <p>

        </p>
        <p>
            <mat-form-field>
                <mat-label>Collection Name</mat-label>
                <input matInput [(ngModel)]="inputData.name" placeholder="Collection Name" />
            </mat-form-field>
        </p>
        <p>
            <mat-form-field>
                <mat-label>Collection Description</mat-label>
                <textarea matInput [(ngModel)]="inputData.description" placeholder="Description">
                      </textarea>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field>
                <mat-label>Choose a target partition</mat-label>
                <mat-select [(ngModel)]="inputData.targetPartition">
                    <mat-option *ngFor="let migration of allowedMigrations"
                        [value]="migration">{{migration}}</mat-option>
                </mat-select>
            </mat-form-field>
        </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-raised-button mat-dialog-close color="warn">Cancel</button>
        <button mat-raised-button color="primary" [disabled]="migrationDisabled()" (click)="migrate()">
            Migrate
        </button>
    </mat-dialog-actions>
</ng-container>